import { useState } from "react";
import { ArrowRight, CalendarClock, Receipt } from "lucide-react";

import { InputDecimal } from "@/components/ui/input-decimal";

import { MODULOS } from "../lib/formulario";
import { pct, reais, simular } from "../lib/simulacao";

function Simulacao({ taxa }) {
  const [venda, setVenda] = useState("100");
  const s = simular(venda, taxa);
  return (
    <div className="mt-4 rounded-xl bg-muted/40 p-4" data-e2e="simulacao-taxa">
      <div className="flex items-center gap-2 text-sm">
        <span className="text-muted-foreground">Venda de R$</span>
        <div className="w-28"><InputDecimal decimals={2} value={venda} onChange={setVenda} className="h-8 text-sm" /></div>
      </div>
      <div className="mt-3 flex items-end gap-2">
        <ArrowRight className="w-4 h-4 text-muted-foreground mb-1.5" />
        <div>
          <p className="text-xs text-muted-foreground">você recebe</p>
          <p className="text-2xl font-black tabular-nums text-emerald-600 dark:text-emerald-400" data-e2e="simulacao-recebe">{reais(s.recebe)}</p>
        </div>
      </div>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs">
        <span className="text-red-600 dark:text-red-400 tabular-nums">taxa {reais(s.taxa)}</span>
        <span className="flex items-center gap-1 text-muted-foreground"><CalendarClock className="w-3.5 h-3.5" />cai na conta em {s.data}</span>
      </div>
    </div>
  );
}

/** Coluna da direita: o que vai valer, com a simulação ao vivo. */
export default function ResumoForma({ form, canal }) {
  const modulos = MODULOS.filter((m) => form.visivel[m.key]);
  return (
    <aside className="bg-card rounded-2xl border p-5 sm:p-6 lg:sticky lg:top-0" data-e2e="resumo-forma">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-1.5"><Receipt className="w-3.5 h-3.5" />Resumo</p>
      <p className="text-lg font-bold mt-2 truncate">{form.name || "Nova forma de pagamento"}</p>
      <p className="text-sm text-muted-foreground">
        {pct(form.taxa.taxa_percentual)}{Number(form.taxa.taxa_fixa) > 0 ? ` + ${reais(form.taxa.taxa_fixa)}` : ""} · recebe em D+{parseInt(form.taxa.prazo_dias, 10) || 0}
      </p>
      <Simulacao taxa={form.taxa} />
      {!canal && (
        <div className="mt-4 pt-4 border-t">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Aparece em</p>
          {modulos.length ? (
            <div className="flex flex-wrap gap-1.5">{modulos.map((m) => <span key={m.key} className="text-xs px-2 py-1 rounded-full bg-primary/10 text-primary font-medium">{form.nomes[m.key] || m.label}</span>)}</div>
          ) : <p className="text-sm text-amber-600 dark:text-amber-400">Nenhum módulo — ninguém consegue escolher esta forma.</p>}
          {!form.is_active && <p className="text-sm text-amber-600 dark:text-amber-400 mt-2">Forma desativada.</p>}
        </div>
      )}
      <p className="text-[11px] text-muted-foreground mt-4 leading-relaxed">A taxa entra no DRE como dedução da receita e o prazo diz ao Fluxo de Caixa em que dia o dinheiro chega.</p>
    </aside>
  );
}
